import { render, staticRenderFns } from "./RequestsPage.vue?vue&type=template&id=1f82d7c5&scoped=true&"
import script from "./RequestsPage.vue?vue&type=script&lang=js&"
export * from "./RequestsPage.vue?vue&type=script&lang=js&"
import style0 from "./RequestsPage.vue?vue&type=style&index=0&id=1f82d7c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f82d7c5",
  null
  
)

export default component.exports